/* KaminWelt — Ergänzungen: Preis-Schieberegler im Kollektionsfilter */
(function () {
  if (window.__kwExtra) return;
  window.__kwExtra = true;

  function fmt(n) {
    try { return Number(n).toLocaleString('de-DE') + ' €'; } catch (e) { return n + ' €'; }
  }

  function initSlider(range) {
    var ins = range.querySelectorAll('input[type="number"]');
    if (ins.length < 2 || range.previousElementSibling && range.previousElementSibling.classList.contains('kw-slider')) return;
    var lo = ins[0], hi = ins[1];
    var max = parseInt(String(hi.getAttribute('placeholder') || '').replace(/\D/g, ''), 10);
    if (!max || max < 10) return;
    var step = max > 3000 ? 50 : (max > 1000 ? 10 : 5);
    max = Math.ceil(max / step) * step;

    var wrap = document.createElement('div');
    wrap.className = 'kw-slider';
    wrap.innerHTML =
      '<div class="kw-slider__vals"><span data-v="lo"></span><span data-v="hi"></span></div>' +
      '<div class="kw-slider__body">' +
        '<div class="kw-slider__track"><div class="kw-slider__fill"></div></div>' +
        '<input type="range" class="kw-slider__in" data-r="lo" min="0" max="' + max + '" step="' + step + '" aria-label="Mindestpreis">' +
        '<input type="range" class="kw-slider__in" data-r="hi" min="0" max="' + max + '" step="' + step + '" aria-label="Höchstpreis">' +
      '</div>';
    range.parentNode.insertBefore(wrap, range);

    var a = wrap.querySelector('[data-r="lo"]');
    var b = wrap.querySelector('[data-r="hi"]');
    var fill = wrap.querySelector('.kw-slider__fill');
    var vLo = wrap.querySelector('[data-v="lo"]');
    var vHi = wrap.querySelector('[data-v="hi"]');

    function fromInputs() {
      a.value = lo.value ? Math.min(+lo.value, max) : 0;
      b.value = hi.value ? Math.min(+hi.value, max) : max;
      paint();
    }
    function paint() {
      var x = +a.value, y = +b.value;
      fill.style.left = (x / max * 100) + '%';
      fill.style.right = (100 - y / max * 100) + '%';
      vLo.textContent = fmt(x);
      vHi.textContent = fmt(y);
    }
    a.addEventListener('input', function () {
      if (+a.value > +b.value - step) a.value = +b.value - step;
      lo.value = +a.value > 0 ? a.value : '';
      paint();
    });
    b.addEventListener('input', function () {
      if (+b.value < +a.value + step) b.value = +a.value + step;
      hi.value = +b.value < max ? b.value : '';
      paint();
    });
    function apply() {
      var f = range.closest('form');
      if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
    }
    a.addEventListener('change', apply);
    b.addEventListener('change', apply);
    lo.addEventListener('input', fromInputs);
    hi.addEventListener('input', fromInputs);
    fromInputs();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.kw-range'), initSlider);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
